<ng-container *ngIf="controller?.state$ | async as s">

  <!-- No categories means no vessels on the map, and a filter over nothing is
       noise — the section is absent rather than empty. `releaseLiveLayer` drops
       the categories the moment a layer goes, so this tracks the map exactly. -->
  <div class="vr-types" *ngIf="s.availableTypes.length">

    <!-- A div, not a <button>: the header carries its own Clear button, and
         nesting buttons is invalid HTML. -->
    <div class="vr-types__head"
         role="button"
         tabindex="0"
         [class.is-flagged]="s.typeFilter.size > 0"
         [attr.aria-expanded]="expanded"
         (click)="toggle()"
         (keydown.enter)="toggle()"
         (keydown.space)="$event.preventDefault(); toggle()">
      <mat-icon class="material-icons-outlined vr-types__icon">filter_alt</mat-icon>
      <span class="vr-types__title">Filter Vessel Types</span>
      <span class="vr-types__count">{{ summary(s.availableTypes.length, s.typeFilter.size) }}</span>
      <span class="vr-types__spacer"></span>

      <button type="button" class="vr-types__clear"
              *ngIf="s.typeFilter.size > 0"
              matTooltip="Show every vessel type again"
              (click)="clear($event)">
        Clear
      </button>

      <mat-icon class="vr-types__caret">{{ expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
    </div>

    <div class="vr-types__body" *ngIf="expanded">
      <!-- Above the chips, not under them: it describes what a tap will do, and
           read after the fact it is an explanation of something already done.

           It also has to be right about the FIRST tap, which is the one that
           surprises. `VesselTypeFilterComponent.toggle` starts from an empty set
           meaning "all shown", so the first chip pressed switches to "only this
           one" — it does not hide that type, it isolates it. Every tap after
           that adds or removes one type, and selecting them all collapses back
           to show-all (which is also what Clear does). -->
      <div class="vr-types__hint">
        Tap a type to show only it, then tap any type to add or remove it.
      </div>
      <app-vessel-type-filter
        [availableTypes]="s.availableTypes"
        [selected]="s.typeFilter"
        (selectionChange)="onSelectionChange($event)">
      </app-vessel-type-filter>
    </div>

  </div>

</ng-container>
